import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Invitation from "@/components/Invitation";
import Museo from "@/components/Museo";
import Timeline from "@/components/Timeline";
import Partners from "@/components/Partners";
import Venue from "@/components/Venue";
import RsvpForm from "@/components/RsvpForm";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, anchors: true, lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8] font-sans text-[#5B5D5D] antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Invitation />
        <Museo />
        <Timeline />
        <Partners />
        <Venue />
        <RsvpForm />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
